import {Universe} from "../../models/Universe";
import {createAction, props} from "@ngrx/store";

export const UPDATE = '[Universe] Update';
export const update = createAction(UPDATE, props<{ universe: Universe }>());
